import React, { useState, useEffect } from 'react';
import { likesAPI } from '../services/api';
import { getProfilePicture, getFirstName } from '../utils/helpers';
import { Link } from 'react-router-dom';

const Visitors = () => {
  const [visitors, setVisitors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchVisitors();
  }, []);

  const fetchVisitors = async () => {
    try {
      const response = await likesAPI.getVisitors();
      setVisitors(response.data.visitors || []);
    } catch (error) {
      console.error('Failed to fetch visitors:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="wrapper">
        <div className="section">
          <div className="container text-center">
            <h3>Loading...</h3>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="matchus-visitors min-h-screen bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 py-6">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Profile Visitors</h1>
          <p className="text-gray-600">People who viewed your profile</p>
        </div>

        {/* Content */}
              {visitors.length === 0 ? (
          <div className="text-center py-16">
            <div className="mb-6">
              <div className="text-6xl mb-4">👀</div>
              <h2 className="text-2xl font-semibold text-gray-900 mb-2">No visitors yet</h2>
              <p className="text-gray-600 max-w-md mx-auto">
                Your profile hasn't been viewed by anyone yet. Share your profile link or be more active to attract visitors!
              </p>
            </div>
            <div className="text-sm text-gray-500">
              💡 Tip: Complete your profile and add recent photos to get more visitors
            </div>
          </div>
        ) : (
          <>
            {/* Stats */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
              <div className="flex items-center justify-center">
                <div className="text-center">
                  <div className="text-2xl font-bold text-blue-500 mb-1">{visitors.length}</div>
                  <div className="text-sm text-gray-600">
                    {visitors.length === 1 ? 'Person viewed your profile' : 'People viewed your profile'}
                  </div>
                </div>
              </div>
            </div>

            {/* Visitors Grid */}
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
                  {visitors.map((visitor) => (
                <Link
                  key={visitor.id}
                  to={`/user/${visitor.viewer_id}`}
                  className="bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md hover:border-blue-200 transition-all duration-200 overflow-hidden group"
                >
                  <div className="aspect-square overflow-hidden">
                    <img
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200"
                      src={getProfilePicture(visitor.viewer)}
                      alt={visitor.viewer.full_name}
                    />
                          </div>
                  <div className="p-3">
                    <h3 className="font-semibold text-gray-900 text-sm mb-1 truncate">
                      {getFirstName(visitor.viewer.full_name)}
                    </h3>
                    <p className="text-xs text-gray-500 mb-1">{visitor.viewer.age} years old</p>
                    <p className="text-xs text-gray-400 truncate">
                      {visitor.viewer.city && `${visitor.viewer.city}`}
                      {visitor.viewer.city && visitor.viewer.country && ', '}
                      {visitor.viewer.country}
                          </p>
                        </div>
                </Link>
                  ))}
                </div>

            {/* Encouragement Message */}
            <div className="mt-8 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-6 text-center">
              <div className="text-2xl mb-2">🚀</div>
              <h3 className="font-semibold text-gray-900 mb-2">Stay Active!</h3>
              <p className="text-gray-600 text-sm">
                The more you interact with others, the more people will visit your profile. Keep swiping and messaging!
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Visitors;

